/* eslint-disable */
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card, Grid
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    Stack, TextField, CardContent, Button, Typography, Box,Chip
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { ToastContainer, toast } from 'react-toastify';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import token from '../../../../helpers/TokenDecoder';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Services';;
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecord: {
        backgroundColor: "green",
    },
    bold: {
        fontWeight: 600,
    }

}));

export default function RouteAddEdit() {
    const classes = useStyles();
    const screenCode = 'ROUTE';
    const navigate = useNavigate();
    const [isButtonEnable, setIsButtonEnable] = useState(false);
    const [groupList, setGroupList] = useState([]);
    const [vehicleList, setVehicleList] = useState([]);
    const [selectvehicleList, setselectvehicleList] = useState([]);
    const [selectvehicleListForUpdate, setselectvehicleListForUpdate] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [productDetails, setProductDetails] = useState([]);
    const [productList, setProductList] = useState([]);
    const [checked, setChecked] = useState([]);
    const [LeftNewArray, setLeftNewArray] = useState([]);
    const [RightNewArray, setRightNewArray] = useState([]);
    const [RightNewArrayAlreadyStoredAccounts, setRightNewArrayAlreadyStoredAccounts] = useState([])
    const [RemovedLedgerAccountList, setRemovedLedgerAccountList] = useState([]);
    const [specialProductcatogery, setSpecialProductcatogery] = useState([]);
    const leftChecked = intersection(checked, LeftNewArray);
    const rightChecked = intersection(checked, RightNewArray);

    function not(a, b) {
        return a.filter((value) => b.map(obj => obj.userID).indexOf(value.userID) === -1);
    }

    function intersection(a, b) {
        return a.filter((value) => b.map(obj => obj.userID).indexOf(value.userID) !== -1);
    }

    const [formData, setFormData] = useState({
        groupID: "0",
        routeCode: "",
        routeName: "",
        routeDescription: "",
        productCategoryID: "0",
        specialProductCategoryID: "0",
        vehicleID: "0",
        isActive: true
    });
    const [tokenData, setTokenData] = useState({
        group: 0,
        factory: 0,
        userID: 0
    });

    const [cropData, setCropData] = useState({
        productCategoryID: '0',
        cropID: '0'
    });

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: false,
        submitButtonName: "Save",
        pageName: "Add Route"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
    });
    const UserRoleSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required'),
        routeCode: Yup.string().required('Route Code required'),
        routeName: Yup.string().required('Route Name required'),
    });

    const { routeID } = useParams();
    let decrypted = 0;

    const handleToggle = (value) => () => {
        const currentIndex = checked.map(obj => obj.userID).indexOf(value.userID);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };

    const handleCheckedRight = () => {
        const updatedRemovedList = RemovedLedgerAccountList.filter(
            (item) => !leftChecked.some((checkedItem) => checkedItem.userID === item.userID)
        );

        setRemovedLedgerAccountList(updatedRemovedList);
        setRightNewArray(RightNewArray.concat(leftChecked));
        setLeftNewArray(not(LeftNewArray, leftChecked));
        setChecked(not(checked, leftChecked));
    };

    const handleCheckedLeft = () => {

        setRemovedLedgerAccountList(RemovedLedgerAccountList.concat(rightChecked))
        setLeftNewArray(LeftNewArray.concat(rightChecked));
        setRightNewArray(not(RightNewArray, rightChecked));
        setChecked(not(checked, rightChecked));
    };

    function handleScreenChange(e, data) {
        const newChecked = [...checked];
        if (e.target.checked) {
            let result = [];
            data.forEach(x => {
                const found = newChecked.find(y => y.userID == x.userID)
                if (found) {
                    result.push(found)
                }
                else {
                    result.push(x)
                }
            })
            setChecked(result);
        }
        else {
            let result = [];
            data.forEach(x => {
                const found = newChecked.find(y => y.userID == x.userID)
                if (!found) {
                    result.push(x)
                }
            })
            setChecked(result);
        }
    }

    function checkSelectLength(checked, items) {
        let result = [];
        items.forEach(x => {
            const found = checked.find(y => y.userID == x.userID)
            if (found) {
                result.push(found)
            }
        })
        if (result.length == items.length) {
            return true;
        }
        else {
            return false;
        }
    }

    const customList = (items) => (
        items.length > 0 ?
            <Paper className={classes.paper}>
                <ListItem role="listitem">
                    <ListItemIcon>
                        <Checkbox
                            color="secondary"
                            onClick={(e) => handleScreenChange(e, items)}
                            checked={items.length != 0 && checkSelectLength(checked, items)}
                        />
                    </ListItemIcon>
                    <ListItemText primary={"Select All"} />
                </ListItem>
                <List dense={true} component="div" role="list" sx={{
                    position: 'relative',
                    overflow: 'auto',
                    maxHeight: 300
                }}>

                    {items.map((value) => {
                        const labelId = `transfer-list-item-${value.userID}-label`;
                        return (
                            <ListItem key={value.userID} role="listitem" button onClick={handleToggle(value)}>
                                <ListItemIcon>
                                    <Checkbox
                                        checked={checked.map(obj => obj.userID).indexOf(value.userID) !== -1}
                                        tabIndex={-1}
                                        color='secondary'
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={value.userName} />
                            </ListItem>
                        );
                    })}
                    <ListItem />
                </List>
            </Paper> : null
    );


    useEffect(() => {
        // trackPromise(
        //     GetRouteMappingDetails()
        // );

        let decrypted = "0";
        if (routeID) {
            decrypted = AESDecryptionParam(routeID);
        }
        if (decrypted !== "0") {
            setPageProps({
                ...pageProps,
                isEdit: true,
                submitButtonName: "Update",
                editingID: parseInt(decrypted),
                pageName: "Edit Route"
            });
            trackPromise(setForEdit(decrypted));
            trackPromise(GetVehicleRouteMappingByRouteID(decrypted));
        } else {
            setPageProps({
                ...pageProps,
                isEdit: false,
                submitButtonName: "Add",
                editingID: null,
                pageName: "Add Route"
            });
            trackPromise(GetRouteDetails());
        }

        const tok = token.getGroupFactoryToken();
        const userID = token.getUserIDFromToken();
        if (tok) {
            setTokenData({
                group: tok.group,
                factory: tok.factory,
                userID: parseInt(userID)
            });
        }
    }, []);

    async function GetUserAgentsByGroupID(groupID) {
        const res = await services.GetUserAgentsByGroupID(groupID);
        if (res != null) {
            setLeftNewArray(res);
        }
    }

    async function setForEdit(id) {
        ClearAllArrays();

        let result = await services.GetRouteDetails(id);
        if (result != null) {
            setValues((prevState) => ({
                ...prevState,
                groupID: result[0].groupID,
                routeID: result[0].routeID,
                routeCode: result[0].routeCode,
                routeName: result[0].routeName,
                routeDescription: result[0].routeDescription,
                isActive: result[0].isActive
            }));
            const productList = await services.GetRouteMappingDetails(id);
            if (productList.length === 0) {
                alert.error("Agents not found");
            } else {
                setRightNewArray(productList);
                setRightNewArrayAlreadyStoredAccounts(productList);
            }
            const groupID = result[0].groupID;
            if (groupID) {
                const userAgents = await services.GetUserAgentsByGroupID(groupID);
                if (userAgents != null) {
                    const filteredAgents = userAgents.filter(agent =>
                        !productList.some(mapped => mapped.userID === agent.userID)
                    );
                    setLeftNewArray(filteredAgents);
                }
            }
        }
    }

    async function GetVehicleRouteMappingByRouteID(routeID) {
        const res = await services.GetVehicleRouteMappingByRouteID(routeID);
        if (res.length === 0) {
            alert.error("vehicles not found");
        } else {
            setselectvehicleList(res);
        }
    }

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            routeCode: formData.routeCode,
            routeName: formData.routeName,
            routeDescription: formData.routeDescription,
            productCategoryID: formData.productCategoryID,
            specialProductCategoryID: formData.specialProductCategoryID,
            vehicleID:formData.vehicleID,
            isActive: formData.isActive
        },

        validationSchema: UserRoleSearchSchema,

        onSubmit: (values) => {
            if (pageProps.isEdit != 0) {
                trackPromise(UpdateRoute(values, tokenData.userID, pageProps.editingID));
            } else {
                trackPromise(SaveRoute(values, tokenData.userID));
            }

        },
    });

    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        if (formik.values.groupID > 0) {
            GetUserAgentsByGroupID(formik.values.groupID);
        }
    }, [formik.values.groupID]);

    useEffect(() => {
        if (formik.values.groupID > 0) {
            GetVehicleByGroupID(formik.values.groupID);
        }
    }, [formik.values.groupID]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWROUTE');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });
        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        })
        GetAllGroups();
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetRouteDetails() {
        var res = await services.GetRouteDetails()
        if (res != null) {
            setProductDetails(res);
        }
    }

    async function GetRouteMappingDetails(routeID) {
        var res = await services.GetRouteMappingDetails(routeID)
        if (res != null) {
            setProductDetails(res);
        }
    }

    async function GetVehicleByGroupID(groupID) {
        var res = await services.GetVehicleByGroupID(groupID)
        if (res != null) {
            setVehicleList(res);
        }
    }

    async function addItem() {
        const selectedID = formik.values.vehicleID;
        if (selectedID && selectedID !== "") {
            const alreadyExists = selectvehicleList.some(item => item.vehicleID === selectedID);
    
            if (alreadyExists) {
                toast.error("Vehicle already added.");
                return;
            }
            const vehicle = vehicleList.find(x => x.vehicleID === selectedID);
            if (vehicle) {
                let temModel = {
                    vehicleID: vehicle.vehicleID,
                    vehicleNumber: vehicle.vehicleNumber
                };
                setselectvehicleList(selectvehicleList => [...selectvehicleList, temModel]);
    
                if (pageProps.isEdit > 0) {
                    setselectvehicleListForUpdate(selectvehicleListForUpdate => [...selectvehicleListForUpdate, temModel]);
                }
                formik.values.vehicleID = "";
            } else {
                toast.error("Invalid vehicle selected.");
            }
        } else {
            toast.error("Please add vehicle.");
        }
    }
    

      async function handleDelete(e) {
        const vehicleID = e.vehicleID;
        const vehicleNumber = e.vehicleNumber;
        if (pageProps.isEdit == true) {
            const vehicleRouteMappingID = e.vehicleRouteMappingID;
            const res = await services.DeleteVehicleRouteMapping(vehicleRouteMappingID ,tokenData.userID);
            if (res > 0) {
                toast.success("Vehicle deleted successfully");
                setselectvehicleList(selectvehicleList.filter(item => item.vehicleID !== vehicleID));
            }
            else {
                toast.error("Vehicle not deleted");
            }
        }else{
            setselectvehicleList(selectvehicleList.filter(item => item.vehicleID !== vehicleID));
        }
      };

    async function SaveRoute(values, user) {
        if(selectvehicleList.length == 0){
            toast.error("Please add vehicle.");
        }
        else{
            let requestModel = {
                routeName: values.routeName,
                routeCode: values.routeCode,
                routeDescription: values.routeDescription,
                groupID: parseInt(values.groupID),
                isActive: values.isActive,
                createdBy: parseInt(user),
                linkedProductList: RightNewArray.map(item => ({
                    userID: item.userID,
                    groupID: parseInt(values.groupID),
                    isActive: values.isActive,
                    createdBy: parseInt(user),
                })),
                vehicleRouteMappingList: selectvehicleList.map(item => ({
                    vehicleID: item.vehicleID,
                    groupID: parseInt(values.groupID),
                    isActive: values.isActive,
                    createdBy: parseInt(user),
                })),
    
            }
            var res = await services.SaveRoute(requestModel);
            if (res.statusCode === "Success") {
                ClearAllArrays();
                toast.success(res.message);
                navigate('/dashboard/route');
                setIsButtonEnable(true);
            } else {
                toast.error(res.message);
            }
        }   
    }

    async function UpdateRoute(values, user, routeID) {
        if(selectvehicleListForUpdate.length == 0 && selectvehicleList.length == 0){
            toast.error("Please add vehicle.");
        }
        else{
            let requestModel = {
                groupID: parseInt(values.groupID),
                routeID: parseInt(routeID),
                routeCode: values.routeCode,
                routeName: values.routeName,
                routeDescription: values.routeDescription,
                isActive: values.isActive,
                createdBy: parseInt(user),
                linkedProductList: not(RightNewArray, RightNewArrayAlreadyStoredAccounts).map(item => ({
                    userID: item.userID,
                    groupID: parseInt(values.groupID),
                    routeID: parseInt(routeID),
                    createdBy: parseInt(user),
                })),
                removedLinkedAccountList: RemovedLedgerAccountList.map(item => ({
                    ...item,
                    userRouteMappingID: item.userRouteMappingID,
                    createdBy: parseInt(user)
                })),
                vehicleRouteMappingList: selectvehicleListForUpdate.map(item => ({
                    vehicleID: item.vehicleID,
                    routeID: parseInt(routeID),
                    groupID: parseInt(values.groupID),
                    isActive: values.isActive,
                    createdBy: parseInt(user),
                })),
            }
            var res = await services.EditRoute(requestModel);
            if (res.statusCode === "Success") {
                toast.success(res.message);
                navigate('/dashboard/route');
                setIsButtonEnable(true);
            } else {
                toast.error(res.message);
            }
        }
    }

    function ClearAllArrays() {
        setChecked([])
        setLeftNewArray([])
        setRightNewArray([])
        setRightNewArrayAlreadyStoredAccounts([])
        setRemovedLedgerAccountList([])
    }

    function clearAll() {
        setValues({
            ...values,
            routeName: "",
            routeDescription: "",
        })
    }

    const { errors, touched, setValues, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    return (
        <>
            <LoadingComponent />
            <Page title="Route |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/route"}
                        btname="Back"
                        pageName={pageProps.pageName}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        // disabled={pageProps.isEdit}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: pageProps.isEdit || !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Route Code *"
                                        value={formik.values.routeCode}
                                        // disabled={pageProps.isEdit}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('routeCode')}
                                        error={Boolean(touched.routeCode && errors.routeCode)}
                                        helperText={touched.routeCode && errors.routeCode}
                                        InputProps={{
                                            readOnly: pageProps.isEdit 
                                        }}
                                    />
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Route Name *"
                                        value={formik.values.routeName}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('routeName')}
                                        error={Boolean(touched.routeName && errors.routeName)}
                                        helperText={touched.routeName && errors.routeName}
                                    />
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Route Description"
                                        value={formik.values.routeDescription}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('routeDescription')}
                                        error={Boolean(touched.routeDescription && errors.routeDescription)}
                                        helperText={touched.routeDescription && errors.routeDescription}
                                    >
                                    </TextField>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Vehicle *"
                                        {...getFieldProps('vehicleID')}
                                        error={Boolean(touched.vehicleID && errors.vehicleID)}
                                        helperText={touched.vehicleID && errors.vehicleID}
                                    >
                                        <MenuItem key={0} value={0}>Select Vehicle</MenuItem>
                                        {vehicleList.map((option) => (
                                            <MenuItem key={option.vehicleID} value={option.vehicleID}>
                                                {option.vehicleNumber}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <Button 
                                        variant="contained" 
                                        color='secondary' 
                                        onClick={() => addItem()}
                                        sx={{ minWidth: '80px' }}
                                    >
                                        Add
                                    </Button>
                                    <Box sx={{ width: '87%' }} />
                                    <Box sx={{ width: '90%' }} />
                                    <Box sx={{ width: '90%' }} />
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <Stack width={375}>
                                    <Paper style={{ marginTop: '3px', width: '100%' }}>
                                    {selectvehicleList.map((vehicle) => (
                                        <Chip
                                        style={{ margin: '2px' }}
                                        label={vehicle.vehicleNumber}
                                        onDelete={(e) => { handleDelete(vehicle) }}
                                        error={Boolean(touched.productVarietyID && errors.productVarietyID)}
                                        helperText={touched.productVarietyID && errors.productVarietyID}
                                        />))}
                                    </Paper>
                                </Stack>
                                </Stack>
                                <Card>
                                    <CardContent>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        </Stack>
                                        <Box marginTop={4} />
                                        {
                                            RightNewArray.length > 0 || LeftNewArray.length > 0 ?
                                                <Grid container spacing={3}>
                                                    <Grid item md={5} xs={12} >
                                                        <Typography variant='h5'>Mobile Users</Typography> <br />
                                                        {customList(LeftNewArray)}
                                                    </Grid>
                                                    <Grid item md={2} xs={12}>
                                                        <Grid container direction="column" alignItems="center" style={{ marginTop: "30%" }}>
                                                            <Button
                                                                variant="outlined"
                                                                size="small"
                                                                color='secondary'
                                                                className={classes.button}
                                                                onClick={handleCheckedRight}
                                                                disabled={leftChecked.length === 0}
                                                                aria-label="move selected right"
                                                            >
                                                                &gt;
                                                            </Button>
                                                            <Button
                                                                variant="outlined"
                                                                size="small"
                                                                color='secondary'
                                                                className={classes.button}
                                                                onClick={handleCheckedLeft}
                                                                disabled={rightChecked.length === 0}
                                                                aria-label="move selected left"
                                                            >
                                                                &lt;
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item md={5} xs={12}>
                                                        <Typography variant='h5'>Mapped Mobile Users</Typography> <br />
                                                        {customList(RightNewArray)}
                                                    </Grid>
                                                </Grid>
                                                : null}
                                    </CardContent>
                                </Card>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                value={formik.values.isActive}
                                                checked={formik.values.isActive}
                                                {...getFieldProps('isActive')}
                                                onClick={formik.handleChange}
                                                color='error'
                                                name="isActive"
                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                            />}
                                        label="Is Active"
                                    />
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        color='error'
                                        onClick={() => clearAll()}
                                    > Clear</Button>
                                    <Button
                                        disabled={isButtonEnable}
                                        type="submit"
                                        variant="contained"
                                        color='secondary'
                                    >{pageProps.submitButtonName}</Button>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                </Container>
            </Page>
        </>
    );
}